import { Toast,PullRefresh  } from 'vant';
import JsBarcode from "jsbarcode";

export default {

  data() {
    return {
      holidayList: [],
      activeIndex: 0,
      backupActiveIndex: 0,
      ourHolidayTabList: [],
      loading: false,
      finished: false,
      length: 0,
      page: 2,
      pageSize: 10,
      playIndex: 0,
      audio: {},
    };
  },

  created() {
    this.getOurHolidayTabList();
    this.audio = new Audio('http://acui.danyang.com/cj_music.mp3');
  },

  mounted() {

  },
  unmounted() {

  },
  methods: {
    playMusic() {
      console.log("playIndex", this.playIndex);
      if(this.playIndex % 2 == 0) {
        this.audio.play().catch(error => {
          console.error('自动播放被浏览器阻止。', error);
        });
      }else{
        this.audio.pause();
      }
      this.playIndex ++;
    },
    getOurHolidayTabList() {
      this.$api.getOurHolidayTabList({
        params: {},
        success: function (res) {
          console.log("res", res.data);
          this.ourHolidayTabList = res.data;
          console.log("ourHolidayTabList", this.ourHolidayTabList);
          console.log("length", this.ourHolidayTabList[0].children.length);
          this.length = this.ourHolidayTabList[0].children.length;
          this.holidayList = this.ourHolidayTabList[0].children.slice(0, this.pageSize);
          console.log("holidayList----", this.holidayList);
          this.finished = false;
          //this.loading = true;
        }.bind(this),
      });
    },
    onClickTab() {
      console.log("activeIndex", this.activeIndex);
      console.log("backupActiveIndex", this.backupActiveIndex);
      console.log("this.finished", this.finished);
      console.log("this.loading", this.loading);
      this.finished = false;
      //this.loading = true;
      if(this.backupActiveIndex != this.activeIndex) {
        this.backupActiveIndex = this.activeIndex;
        let child = this.ourHolidayTabList[this.activeIndex].children;
        console.log("child", child);
        if (child == null || child == "undefined") {
          this.length = 0;
          this.holidayList = [];
          this.finished = true;
          //this.loading = false;
        } else {
          this.holidayList = child.slice(0, this.pageSize);
          this.length = child.length;
          console.log("length", this.length);

        }
        this.page = 2;
        console.log("holidayList", this.holidayList);
      }
    },

    onLoad () {
      setTimeout(() => {
        console.log("this.page", this.page);
        console.log("this.length", this.length);
        this.$api.getOurHolidayList({
          params: {
            'activeIndex': this.activeIndex,
            'page': this.page,
            'pageSize': this.pageSize
          },
          success: function (res) {
            if (res.code === 0 && Array.isArray(res.data)) {
              this.holidayList.push(...res.data)
              console.log(":::holidayList", this.holidayList)
              // 加载状态结束
              this.loading = false;
              this.page ++;
              this.activeIndex = this.backupActiveIndex;
            }
          }.bind(this),
        })
        // 数据全部加载完成
        if (this.holidayList.length >= this.length) {
          this.finished = true;
          this.activeIndex = this.backupActiveIndex;
        }
      }, 1000);
    },
    gotoDetail(href){
      console.log(":::href", href);
      window.location.href = href;
    }
  },
};
